import axios from "axios";
import { API_URL } from "@/config";
import downloadFile from "@/utils/downloadFile";
import { resetStateToDefault } from "@/lib/store/index";

const defaultState = Object.freeze({
  unseenAnnouncementsIds: [],
  modalVisible: false,
});

export default {
  namespaced: true,

  state: {
    ...defaultState,
  },

  getters: {
    hasUnseenAnnouncements: (state) => state.unseenAnnouncementsIds.length > 0,
    modalVisible: (state) => state.modalVisible,
  },

  mutations: {
    setAnnouncementsThatUserShouldSeeAtLogin(state, unseenAnnouncementsIds) {
      state.unseenAnnouncementsIds = unseenAnnouncementsIds;
    },

    setModalVisible(state, visible) {
      state.modalVisible = visible;
    },

    resetState(state) {
      resetStateToDefault(state, defaultState);
    },
  },

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/announcements`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, announcementId) {
      const response = await axios.get(`${API_URL}/announcements/${announcementId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, formData) {
      const response = await axios.post(`${API_URL}/announcements`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { announcementId, formData }) {
      const response = await axios.post(`${API_URL}/announcements/${announcementId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, announcementId) {
      const response = await axios.delete(`${API_URL}/announcements/${announcementId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async download(_, { announcementId, attachmentId }) {
      const response = await axios({
        url: `${API_URL}/announcements/${announcementId}/attachments/${attachmentId}/download`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      downloadFile(response);
    },

    async attachmentDelete(_, { announcementId, attachmentId }) {
      const response = await axios.delete(
        `${API_URL}/announcements/${announcementId}/attachments/${attachmentId}/delete`,
      );

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async markAllAsSeen({ commit }) {
      const response = await axios.post(`${API_URL}/announcements/markAllAsSeen`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      commit("setAnnouncementsThatUserShouldSeeAtLogin", []);

      return true;
    },
  },
};
